{
  "processPage": {
    "assignmentTitle": "Prozessschritt-Zuweisung überprüfen",
    "assignmentDescription": "Prüfe die Zuweisungsdetails. Wenn alles passt, akzeptiere und beginne mit der Aufnahme deines Prozessschritts. Bist du nicht die richtige Person, weise den Schritt jemand anderem zu.",
    "YourProcessStep": "Dein Prozessschritt",
    "ProcessStart": "Prozessstart",
    "Output": "Ausgabe",
    "Successor": "Nachfolger",
    "Assignee": "Bearbeiter",
    "chooseAllSuccessor": "Wähle alle Nachfolger, die deine Ausgabe erhalten sollen.",
    "chooseAllSuccessorDecision": "Wähle alle Nachfolger aus, die bei dieser Option den Prozess fortsetzen.",
    "chooseASuccessor": "Wähle einen Nachfolger, der deine Ausgabe erhalten soll.",
    "chooseAllAssignee": "Wähle alle Personen, die den Prozess starten können.",
    "chooseAnAssignee": "Wähle, wer den Prozess starten soll.",
    "aSuccessorCanBe": "Ein Nachfolger kann eine Person, eine Funktion, ein System oder ein externer Kontakt sein.",
    "anAssigneeCanBe": "Ein Bearbeiter kann eine Person, eine Funktion oder ein System sein.",
    "addSuccessor": "Nachfolger hinzufügen",
    "addAssignee": "Bearbeiter hinzufügen",
    "whoElseDoesThis": "Wer macht das noch?",
    "selectColleaguesWhoAlsoPerform": "Wähle Personen, die diesen Schritt unabhängig von dir übernehmen könnten – z.B. als Vertretung. Mehrere möglich.",
    "statusPending": "Ausstehend",
    "Person": "Person",
    "thisPersonWillReceive": "Diese Person erhält eine Einladung, den nächsten Prozessschritt zu beschreiben.",
    "thisPersonWillReceiveStart": "Diese Person wird eingeladen, den ersten Prozessschritt zu beschreiben.",
    "teamWillReceive": "Diese Funktion erhält eine Einladung, den nächsten Prozessschritt zu beschreiben.",
    "teamWillReceiveStart": "Diese Funktion wird eingeladen, den ersten Prozessschritt zu beschreiben.",
    "Unclear": "Unklar",
    "processWillEnd": "Die Prozesssequenz endet hier",
    "processWillReturnToOwner": "Der Prozess wird an den Prozessverantwortlichen zurückgegeben",
    "None": "Kein Nachfolger",
    "systemOwnerWillReceive": "Der Systemverantwortliche wird eingeladen, den nächsten Prozessschritt zu beschreiben.",
    "systemOwnerWillReceiveStart": "Der Systemverantwortliche wird eingeladen, den ersten Prozessschritt zu beschreiben.",
    "externalContactOwnerWillReceive": "Der Prozessverantwortliche wird eingeladen, den Schritt stellvertretend für den externen Kontakt zu beschreiben.",
    "selectPersonPlaceholder": "Person auswählen...",
    "selectSystemPlaceholder": "Software/System auswählen...",
    "selectExternalContactPlaceholder": "Externen Kontakt auswählen...",
    "Processname": "Prozessname",
    "processFlow": "Prozessablauf",
    "processFlowDescription": "Zeige das vollständige Prozessablaufdiagramm mit allen aufgezeichneten Schritten",
    "showInProcess": "Im Prozess anzeigen",
    "viewProcessDetails": "Prozessdetails anzeigen",
    "assignSomeoneElse": "Jemand anderem zuweisen",
    "Saved": "Gespeichert",
    "unsavedChanges": "Ungespeicherte Änderungen",
    "processNameDesc": "Prozessdetails",
    "multiple-times-daily": "Mehrmals täglich",
    "once-a-day": "Einmal am Tag",
    "several-times-a-week": "Mehrmals pro Woche",
    "once-per-week": "Einmal pro Woche",
    "every-two-weeks": "Alle zwei Wochen",
    "every-three-weeks": "Alle drei Wochen",
    "monthly": "Monatlich",
    "quarterly": "Vierteljährlich",
    "semi-annually": "Halbjährlich",
    "yearly": "Jährlich",
    "LastChange": "Letzte Änderung",
    "ProcessStepMembers": "Prozessschritt-Mitglieder",
    "ProcessStep": "Prozessschritt",
    "Check": "Überprüfen",
    "ratingRequired": "Bewertung ist erforderlich",
    "Saving": "Speichern...",
    "surveyRequired": "Bitte gib eine Antwort an",
    "total": "Gesamt: {{total}}",
    "showSelected": "Ausgewählte anzeigen ({{amount}})",
    "Reassign": "Neu zuweisen",
    "AllDepartments": "Alle Abteilungen"
  },
  "processFlow": {
    "bpmnPreview": "Prozessvorschau",
    "openFullscreen": "Vollbild öffnen",
    "fullscreenTitle": "Prozessfluss-Visualisierung",
    "viewMode": {
      "label": "Ansicht",
      "standard": "Standard",
      "rating": "Nach Bewertung",
      "capacity": "Nach Kapazitätsbindung",
      "combined": "Kombi-Score"
    },
    "heatmapLegend": {
      "noData": "Keine Daten",
      "rating": {
        "good": "Ø ≥ {{min}} Sterne",
        "medium": "Ø {{min}} – {{max}} Sterne",
        "critical": "Ø < {{min}} Sterne"
      },
      "capacity": {
        "good": "< {{max}} % des Maximums",
        "medium": "{{min}} – {{max}} % des Maximums",
        "critical": "≥ {{min}} % des Maximums"
      },
      "combined": {
        "good": "Score ≥ {{min}} %",
        "medium": "Score {{min}} – {{max}} %",
        "critical": "Score < {{max}} %"
      },
      "hoursUnit": "h",
      "combinedInfo": "Der Kombi-Score bewertet jeden Schritt von 0–100 % und verbindet dabei zwei Dinge: wie gut seine Bewertung ist (60 %) und wie gering seine Kapazitätslast ist (40 %) – ein Schritt, der weniger Stunden bindet, erzielt einen höheren Wert. Grün heißt gut in beidem; Rot heißt schlechte Bewertung, hohe Kapazitätslast – oder beides."
    },
    "stepDetails": "Details zu Schritt {{number}}",
    "stepPrefix": "Schritt {{number}}",
    "decision": "Entscheidung",
    "assignedTo": "Zugewiesen an",
    "recordedBy": "Aufgenommen von",
    "taskDescription": "Aufgabenbeschreibung",
    "inputs": "Eingänge",
    "inputsHint": "Füge hier alles hinzu, was hereinkommt und du benötigst, um den Prozessschritt umzusetzen: ein Ereignis, das den Schritt auslöst (z.B. Quartalsmeeting) oder eine Information, die du verarbeitest (z.B. ein Bericht oder Kennzahl). Reine Nachschlagewerke wie Richtlinien gehören dagegen unter „Unterlagen“.",
    "helpers": "Helfer",
    "helpersHint": "Womit und mit wem erledigst du diesen Schritt? Genutzte Systeme, zwingend eingebundene Personen und Funktionen sowie benötigte Unterlagen.",
    "persons": "Person(en)",
    "teams": "Funktion(en)",
    "systems": "System(e)",
    "documents": "Dokument(e)",
    "successors": "Nachfolger",
    "noSuccessors": "Prozess endet hier",
    "unclearSuccessors": "Unklare Fortsetzung",
    "pendingSystem": "Vorgeschlagenes System",
    "pendingOrgFunction": "Vorgeschlagene Funktion",
    "decisionRules": "Entscheidungsregeln",
    "whoElseDoesThis": "Wer macht das noch",
    "whoElseDoesThisDescription": "Wähle Personen, die diesen Schritt unabhängig von dir übernehmen könnten – z.B. als Vertretung. Mehrere möglich.",
    "whoElseDoesThisDescriptionEditor": "Personen, die diesen Schritt ebenfalls ausführen – z.B. als Vertretung. Mehrere möglich.",
    "status": {
      "pending": "Ausstehend",
      "accepted": "Akzeptiert",
      "declined": "Abgelehnt"
    },
    "feedback": "Rückmeldung",
    "variantCheck": {
      "title": "Variantenabfrage",
      "same": "genau so",
      "different": "anders",
      "notPerformed": "macht nicht",
      "viewVariants": "Varianten ansehen"
    },
    "createdAt": "Erstellt",
    "updatedAt": "Aktualisiert",
    "completedAt": "Abgeschlossen",
    "noStepsRecorded": "Noch keine Prozessschritte aufgezeichnet",
    "startRecordingHint": "Starte die Aufzeichnung, um den Prozessablauf zu sehen",
    "output": "Ergebnis",
    "expandTable": "Tabelle vergrößern",
    "endLabel": "Ende",
    "noFurtherSteps": "Keine weiteren Schritte",
    "unclearContinuation": "Unklare Fortführung",
    "swimlane": {
      "unassigned": "Nicht zugewiesen"
    },
    "viralPlaceholder": {
      "pending": "Aufnahme ausstehend",
      "accepted": "Aufnahme läuft",
      "pendingUnclear": "Unklar — wartet auf Klärung durch den Prozessverantwortlichen",
      "proposed": "Vorgeschlagen — wartet auf Freigabe",
      "declined": "Vorgeschlagen — abgelehnt"
    },
    "editable": {
      "noAssignee": "Kein Zuständiger",
      "addInput": "Eingabe hinzufügen",
      "reorderInput": "Zum Umsortieren ziehen",
      "removeInput": "Eingabe entfernen",
      "addHelper": "Helfer hinzufügen",
      "addArtifact": "Neues Dokument hinzufügen",
      "noSuccessors": "Keine Nachfolger festgelegt",
      "addSuccessor": "Nachfolger hinzufügen",
      "removeSuccessor": "Nachfolger entfernen",
      "noDecisionRules": "Keine Entscheidungsregeln definiert",
      "editDecisionRules": "Entscheidungsregeln bearbeiten",
      "noHelpers": "Keine Helfer ausgewählt",
      "editHelpers": "Helfer bearbeiten",
      "editHelpersDescription": "Wähle Personen, Funktionen und Systeme aus, die bei diesem Schritt helfen.",
      "none": "Keine",
      "personsCount": "{{count}} Personen",
      "personsCount_one": "{{count}} Person",
      "personsCount_other": "{{count}} Personen",
      "teamsCount": "{{count}} Funktionen",
      "teamsCount_one": "{{count}} Funktion",
      "teamsCount_other": "{{count}} Funktionen",
      "systemsCount": "{{count}} Systeme",
      "systemsCount_one": "{{count}} System",
      "systemsCount_other": "{{count}} Systeme",
      "documentsCount": "{{count}} Dokumente",
      "documentsCount_one": "{{count}} Dokument",
      "documentsCount_other": "{{count}} Dokumente"
    },
    "contextMenu": {
      "addStep": "Neuen Schritt hinzufügen",
      "addEvent": "Ereignis hinzufügen",
      "addEventForStep": "Ereignis für Schritt hinzufügen",
      "editStep": "Schritt bearbeiten",
      "deleteStep": "Schritt löschen",
      "editEvent": "Ereignis bearbeiten",
      "deleteEvent": "Ereignis löschen",
      "markAsEnd": "Als Ende markieren",
      "markUnclear": "Als unklar markieren",
      "convertToAssignment": "In Zuweisung umwandeln",
      "convertToStep": "In Schritt umwandeln",
      "mergeNode": "Zusammenführen mit …",
      "mergeDisabledHasSuccessor": "Nur Schritte ohne Nachfolger können zusammengeführt werden",
      "insertBetween": "Schritt dazwischen einfügen",
      "forkFromSource": "Parallelen Zweig eröffnen",
      "mergeIntoTarget": "Parallelen Zweig zusammenführen",
      "deleteEdge": "Löschen",
      "saveAsStepTemplate_one": "Als Schrittvorlage speichern ({{count}} Element)",
      "saveAsStepTemplate_other": "Als Schrittvorlage speichern ({{count}} Elemente)",
      "insertStepTemplate": "Aus Schrittvorlage einfügen"
    },
    "mergeDialog": {
      "title": "Schritte zusammenführen",
      "description": "Wähle einen weiteren Schritt zum Zusammenführen und entscheide dann, welcher Schritt bleibt.",
      "selectCandidate": "Schritt zum Zusammenführen",
      "searchCandidates": "Schritte suchen …",
      "noCandidates": "Keine weiteren Schritte zum Zusammenführen",
      "unnamedNode": "Unbenannter Schritt",
      "assignedTo": "Zugewiesen an: {{name}}",
      "survivorLabel": "Welcher Schritt soll bleiben?",
      "keepSource": "„{{name}}“ behalten",
      "keepTarget": "„{{name}}“ behalten",
      "resultKindStep": "Das Ergebnis wird ein Schritt.",
      "resultKindAssignment": "Das Ergebnis wird eine Zuweisung.",
      "confirm": "Zusammenführen",
      "cancel": "Abbrechen"
    },
    "detailPanel": {
      "dragToMove": "Zum Verschieben ziehen (Doppelklick zum Zurücksetzen)",
      "dragToResize": "Zum Ändern der Größe ziehen"
    }
  },
  "processDetail": {
    "editProcess": "Prozess bearbeiten",
    "export": {
      "title": "Prozess exportieren",
      "button": "Exportieren",
      "description": "Wählen Sie aus, welche Abschnitte in die heruntergeladene JSON-Datei aufgenommen werden.",
      "steps": "Schritte",
      "assignments": "Zuweisungen",
      "capacity": "Kapazität (sensibel)",
      "context": "Organisationskontext (Rollen, Abteilungen, Systeme, Teams, Organigramm)",
      "format": "Format",
      "formatJson": "JSON",
      "formatYaml": "YAML",
      "formatExcel": "Excel",
      "includeMetrics": "Kennzahlen einschließen (Bewertung, Häufigkeit, Dauer, Kapazitätsbindung)",
      "download": "Herunterladen",
      "cancel": "Abbrechen",
      "success": "Prozess exportiert",
      "error": "Prozess konnte nicht exportiert werden",
      "capacitySource": "Kapazitätsquelle",
      "capacitySourceSurvey": "erhoben",
      "capacitySourceManual": "manuell erfasst"
    }
  },
  "processFlowEditor": {
    "newTask": "Neue Aufgabe",
    "newDecision": "Neue Entscheidung",
    "emptyNote": "Leere Notiz",
    "noteLink": "Mit Schritten verknüpfen",
    "noteLinkHint": "Schritte anklicken zum Verknüpfen oder Lösen · leere Fläche klicken zum Beenden",
    "noteCategory": {
      "context": "Kontext",
      "problem": "Problem",
      "question": "Frage",
      "todo": "To-do"
    },
    "ruleNoOutput": "Regel hat keine ausgehende Verbindung oder keinen Endzustand",
    "eventDisconnected": "Ereignis hat keine ausgehende Verbindung",
    "sendInvitations": "Einladungen senden",
    "noInvitations": "Keine Einladungen zu versenden",
    "sendAll": "Alle senden",
    "savePositions": "Positionen speichern",
    "pendingInvitations": "Ausstehende Einladungen ({{count}})",
    "swimlane": {
      "moveUp": "Bahn nach oben",
      "moveDown": "Bahn nach unten",
      "color": "Farbe",
      "resetColor": "Farbe zurücksetzen",
      "customColorPlaceholder": "#RRGGBB",
      "applyColor": "Übernehmen"
    }
  },
  "processDraft": {
    "preparing": "Entwurf wird vorbereitet...",
    "loadError": "Entwurf konnte nicht geladen werden.",
    "refetchErrorBanner": "Änderungen werden derzeit nicht gespeichert — Verbindungs- oder Sitzungsproblem. Bitte lade die Seite neu.",
    "draftBadge": "Entwurf",
    "lastSaved": "Zuletzt gespeichert {{when}}",
    "publish": "Veröffentlichen",
    "discard": "Entwurf verwerfen",
    "discardConfirm": "Änderungen verwerfen?",
    "addStep": "Schritt hinzufügen",
    "addNote": "Notiz hinzufügen",
    "stepDetail": "Schritt",
    "assigneeSet": "Zuständiger ausgewählt",
    "assigneeNone": "Noch kein Zuständiger",
    "pickAssignee": "Zuständigen wählen",
    "pickActionType": "Bitte Aktionstyp wählen.",
    "needsInput": "Eingabe erforderlich",
    "decisionEditNotice": "Entscheidungsregeln werden nach dem Veröffentlichen am Live-Schritt bearbeitet.",
    "taskDescription": "Aufgabenbeschreibung",
    "taskDescriptionPlaceholder": "Was passiert in diesem Schritt?",
    "confirmDeleteStep": "Diesen Schritt aus dem Entwurf löschen?",
    "confirmDisconnect": "Diese Verbindung entfernen?",
    "editor": {
      "generateWithAi": "Mit KI generieren",
      "generateWithAiDisabled": "Füge zuerst Eingänge, eine Aufgabenbeschreibung oder Regeln hinzu",
      "generateWithAiError": "Schrittzusammenfassung konnte nicht generiert werden",
      "descriptionPlaceholder": "Fasse diesen Schritt zusammen…"
    },
    "mode": {
      "manual": "Manuell",
      "viral": "Viral",
      "viralDisabledReason": "Nur Endschritte mit einer vorgelagerten Quelle können zu viralen Zuweisungen werden."
    },
    "surveys": {
      "heading": "Umfragen",
      "reRequestToggleLabel": "Umfrage beim Veröffentlichen erneut anfordern",
      "reRequestToggleHint": "Beim Veröffentlichen werden die Beteiligten dieses Schritts erneut gebeten, ihre Umfrage auszufüllen.",
      "publishReRequestAll": "Veröffentlichen & alle Umfragen erneut anfordern",
      "reRequestShort": "Erneut anfordern",
      "reRequestShortActive": "Wird angefordert",
      "status": {
        "pending": "Ausstehend",
        "completed": "Abgeschlossen",
        "dismissed": "Macht den Schritt nicht",
        "toCreate": "Wird erstellt",
        "invited": "Eingeladen"
      },
      "variantStatus": {
        "pending": "Variantenabfrage offen",
        "answered": "Variantenabfrage beantwortet",
        "notApplicable": "Keine Variantenabfrage"
      },
      "statusNone": "Noch keine Umfragen"
    },
    "unclearSuccessor": {
      "label": "Unklarer Nachfolger"
    },
    "actionType": {
      "task": "Aktivität",
      "decision": "Entscheidung"
    },
    "actionTypeHint": "Beschreibe, was in diesem Schritt geschieht. Ist es eine normale Tätigkeit, wähle „Aktivität“. Hängt der weitere Verlauf von Bedingungen ab (z.B. genehmigt/abgelehnt), wähle „Entscheidung“.",
    "card": {
      "unconfigured": "Nicht konfigurierter Schritt",
      "taskLabel": "Aufgabe (ohne Beschreibung)",
      "decisionLabel": "Entscheidung (ohne Regeln)",
      "assigned": "Zugewiesen",
      "pickAssignee": "Zuständigen wählen",
      "needsInput": "Eingabe erforderlich",
      "willInvite": "Einladung geplant"
    },
    "graphReason": {
      "no-inputs": "Schritt hat keinen Eingang",
      "no-outputs": "Schritt hat keinen Nachfolger",
      "orphan": "Schritt ist nicht verbunden",
      "no-start-event": "Der Prozess hat kein Startereignis — öffne den Editor erneut, um es wiederherzustellen",
      "event-disconnected": "Ereignis hat keine ausgehende Verbindung",
      "event-disconnected-named": "Ereignis „{{name}}\" hat keine ausgehende Verbindung",
      "rule-no-output": "Regel „{{output}}\" hat keine ausgehende Verbindung oder keinen Endzustand",
      "rule-no-output-unnamed": "Eine Entscheidungsregel hat keine ausgehende Verbindung oder keinen Endzustand",
      "unreachable": "Schritt ist vom restlichen Prozess abgeschnitten",
      "unreachable-named": "Ereignis „{{name}}\" ist vom restlichen Prozess abgeschnitten"
    },
    "publishErrors": {
      "title": "Veröffentlichung blockiert",
      "goToStep": "Zum Schritt",
      "unnamedStep": "Unbenannter Schritt",
      "unnamedEvent": "Unbenanntes Ereignis",
      "processLevel": "Prozess",
      "fieldLabels": {
        "actionType": "Schritt-Typ",
        "taskDescription": "Aufgabenbeschreibung",
        "output": "Ergebnistext",
        "rules": "Regeln",
        "assignedTo": "Zuständig",
        "inputs": "Eingaben",
        "helpers": "Hilfsmittel",
        "helperPersons": "Helfer (Personen)",
        "helperOrgFunctions": "Helfer (Funktionen)",
        "helperSystems": "Helfer (Systeme)",
        "helperDocuments": "Helfer (Dokumente)",
        "whoElseDoesThis": "Weitere Beteiligte",
        "generatedName": "Schrittname",
        "generatedDescription": "Schrittbeschreibung",
        "manualCapacity": "Manuelle Kapazität"
      },
      "issueMessages": {
        "actionTypeRequired": "Schritt-Typ ist erforderlich",
        "taskDescriptionRequired": "Aufgabenbeschreibung ist erforderlich",
        "taskOutputRequired": "Ergebnistext ist erforderlich",
        "rulesRequired": "Mindestens eine Entscheidungsregel ist erforderlich",
        "ruleOutputRequired": "Regel-Ergebnis ist erforderlich",
        "ruleConditionRequired": "Regel muss mindestens einen ausgefüllten Bedingungswert haben",
        "stepAssigneeRequired": "Schritt braucht einen Zuständigen",
        "assignmentAssigneeRequired": "Zuweisung braucht einen Zuständigen",
        "assignmentInputRequired": "Zuweisung braucht mindestens einen Eingang aus einem vorgelagerten Schritt",
        "eventNameRequired": "Ereignisname ist erforderlich",
        "startEventDescriptionRequired": "Beschreibung des Startereignisses ist erforderlich"
      }
    },
    "draftConflict": {
      "title": "Editor-Bearbeitung und dezentrale Aufnahme stehen im Konflikt",
      "body": "In der dezentralen Aufnahme wurden Prozessschritte aufgenommen, die einen anderen Prozessverlauf darstellen als der letzte unveröffentlichte Stand im Editor.",
      "yours": "Editor-Entwurf",
      "live": "Dezentrale Aufnahme",
      "listEmpty": "(keine)",
      "unnamedItem": "(unbenannt)",
      "cancel": "Editor-Entwurf beibehalten (der Stand der dezentralen Aufnahme wird überschrieben)",
      "discard": "Editor-Entwurf verwerfen (der Stand der dezentralen Aufnahme ist korrekt)",
      "discardModalTitle": "Editor-Entwurf wirklich verwerfen?",
      "discardModalBody": "Dadurch wird dein gesamter Editor-Entwurf endgültig gelöscht — alle Änderungen in allen Schritten, nicht nur in diesem. Der Entwurf wird neu aus dem aktuellen Stand der dezentralen Aufnahme erstellt. Dies kann nicht rückgängig gemacht werden.",
      "discardModalCancel": "Editor-Entwurf behalten",
      "discardModalConfirm": "Editor-Entwurf verwerfen",
      "publishAnyway": "Editor-Entwurf beibehalten (der Stand der dezentralen Aufnahme wird überschrieben)",
      "publishAnywayModalTitle": "Stand der dezentralen Aufnahme überschreiben?",
      "publishAnywayModalBody": "Du überschreibst den aktuellen Stand der dezentralen Aufnahme mit deinem Editor-Entwurf. Laufende dezentrale Aufnahmen — offene Einladungen — können dabei verloren gehen oder ungültig werden. Das kann nicht rückgängig gemacht werden.",
      "publishAnywayModalCancel": "Zurück",
      "publishAnywayModalConfirm": "Überschreiben",
      "unnamedStep": "Unbenannter Schritt",
      "empty": "Schritt extern geändert",
      "changesCount_one": "{{count}} Änderung",
      "changesCount_other": "{{count}} Änderungen"
    },
    "publishUnknownError": "Veröffentlichung fehlgeschlagen — bitte erneut versuchen.",
    "invitesFailedToast_one": "Der Entwurf wurde veröffentlicht, aber {{count}} Einladung konnte nicht gesendet werden. Betroffene Empfänger müssen erneut eingeladen werden.",
    "invitesFailedToast_other": "Der Entwurf wurde veröffentlicht, aber {{count}} Einladungen konnten nicht gesendet werden. Betroffene Empfänger müssen erneut eingeladen werden.",
    "issues": {
      "count_one": "{{count}} Problem",
      "count_other": "{{count}} Probleme",
      "title": "Vor dem Veröffentlichen",
      "none": "Keine Probleme",
      "kinds": {
        "actionType": {
          "title": "Schritt-Typ fehlt"
        },
        "taskDescription": {
          "title": "Aufgabenbeschreibung fehlt"
        },
        "output": {
          "title": "Ergebnis fehlt"
        },
        "assignee": {
          "title": "Zuständig fehlt"
        },
        "rules": {
          "title": "Keine Entscheidungsregel"
        },
        "ruleOutput": {
          "title": "Regel {{number}}: Ergebnis fehlt"
        },
        "ruleCondition": {
          "title": "Regel {{number}}: Bedingung fehlt"
        },
        "assignmentInput": {
          "title": "Eingang fehlt",
          "hint": "Verbinde einen vorherigen Schritt mit diesem Platzhalter."
        },
        "eventName": {
          "title": "Ereignisname fehlt"
        },
        "eventDescription": {
          "title": "Beschreibung fehlt"
        },
        "noInputs": {
          "title": "Kein Eingang",
          "hint": "Ziehe eine Verbindung von einem vorherigen Schritt hierher."
        },
        "noOutputs": {
          "title": "Kein Nachfolger",
          "hint": "Verbinde einen nächsten Schritt oder markiere den Schritt als Ende."
        },
        "decisionNoOutputs": {
          "title": "Keine Regel hat ein Ziel",
          "hint": "Verbinde jede Regel mit einem Schritt oder markiere sie als Ende."
        },
        "orphan": {
          "title": "Nicht verbunden",
          "hint": "Verbinde den Schritt mit dem Ablauf – oder lösche ihn."
        },
        "ruleNoOutput": {
          "title": "Regel „{{output}}“ hat kein Ziel",
          "titleUnnamed": "Eine Regel hat kein Ziel",
          "hint": "Verbinde die Regel mit einem Schritt oder markiere sie als Ende."
        },
        "eventDisconnected": {
          "title": "Ereignis nicht verbunden",
          "hint": "Verbinde das Ereignis mit dem Schritt, den es auslöst."
        },
        "unreachable": {
          "title": "Vom Ablauf abgeschnitten",
          "hint": "Verbinde diesen Teil mit dem restlichen Prozess."
        },
        "noStartEvent": {
          "title": "Kein Startereignis",
          "hint": "Öffne den Editor erneut, um es wiederherzustellen."
        }
      }
    },
    "startEvent": {
      "title": "Startereignis",
      "titleHint": "Jedes Startereignis eines Prozesses führt zu einer Aktivität, die in Deinem Unternehmen stattfindet. Erzähl uns, wer diese Aktivität ausführt, wann immer das Startereignis stattfindet.",
      "eventTypeLabel": "Auslöser",
      "eventTypeHint": "Der Auslöser bestimmt, wodurch der Prozess startet.\n\nManueller Start = Eine Person stößt den Prozess aktiv an.\nEingehende Anfrage = Eine E-Mail, ein Antrag oder ein anderes System o.ä. startet den Prozess.\nZeitpunkt / Frist = Der Prozess startet zu einem Termin oder wiederkehrend (z.B. monatlich).",
      "nameLabel": "Ereignisname",
      "descriptionLabel": "Beschreibung",
      "namePlaceholder": "Was löst diesen Prozess aus?",
      "descriptionPlaceholder": "Beschreibe, was dieses Ereignis auslöst (z.B. Mitarbeiter reicht Urlaubsantrag ein)",
      "assigneeCardSubtitle": "Wähle aus, wer oder was mit dem Startereignis weiterarbeitet",
      "assigneeCardHelper": "Du kannst das Startereignis an einen oder mehrere Personen, Funktionen (Rollen oder Teams) oder Systeme zuweisen."
    },
    "event": {
      "title": "Ereignis",
      "eventTypeLabel": "Ereignistyp",
      "nameLabel": "Name",
      "descriptionLabel": "Beschreibung",
      "namePlaceholder": "Wofür steht dieses Ereignis?",
      "descriptionPlaceholder": "Beschreibe das Ereignis"
    },
    "capacity": {
      "title": "Kapazität",
      "enter": "Manuell erfassen",
      "shadowHint": "manuell erfasst — erhobener Wert hat Vorrang",
      "excludedBySettingHint": "manuell erfasst — Einstellung „Kapazitätsquelle“ schließt manuelle Werte aus",
      "dialogTitle": "Kapazität manuell erfassen",
      "frequency": "Häufigkeit",
      "timesPerPeriod": "Anzahl",
      "duration": "Dauer (Minuten)",
      "preview": "≈ {{month}} h/Monat · {{year}} h/Jahr pro Person — wird wie eine Erhebungsantwort auf das Team hochgerechnet",
      "previewPerPerson": "≈ {{month}} h/Monat · {{year}} h/Jahr pro Person",
      "previewTeamTotal": "× {{count}} Teammitglieder ≈ {{month}} h/Monat · {{year}} h/Jahr gesamt",
      "previewTotal": "≈ {{month}} h/Monat · {{year}} h/Jahr gesamt",
      "attribution": "manuell erfasst von {{name}} am {{date}}",
      "remove": "Entfernen",
      "primitives": "{{frequency}} · {{minutes}} min",
      "saveError": "Kapazität konnte nicht gespeichert werden."
    }
  },
  "processes": {
    "title": "Prozesse",
    "description": "Übersicht aller Prozesse in deiner Organisation",
    "search": "Prozesse suchen...",
    "createProcess": "Prozess erstellen",
    "editDetails": "Details bearbeiten",
    "createProcessDescription": "Füge einen neuen Prozess zu deiner Organisation hinzu",
    "editProcessDescription": "Aktualisiere die Details dieses Prozesses",
    "empty": "Keine Prozesse gefunden",
    "nameLabel": "Prozessname",
    "owner": "Verantwortlicher",
    "ownerPlaceholder": "Prozessverantwortlichen auswählen",
    "accountableClearLabel": "Standard (Abteilungsleiter)",
    "accountablePlaceholder": "Niemand ausgewählt",
    "department": "Abteilung",
    "departmentPlaceholder": "Abteilung auswählen",
    "ownerAndDepartmentEditHint": "Kontaktiere deinen Organisationsmanager, um die Abteilung oder den Prozessverantwortlichen zu ändern",
    "namePlaceholder": "Prozessnamen eingeben, z.B. Urlaubsantrag einreichen",
    "descriptionPlaceholder": "Prozessbeschreibung eingeben, z.B. „Prozess beschreibt den Ablauf eines Urlaubsantrags von der Antragsstellung bis zur Bewilligung“",
    "category": "Prozesskategorie",
    "categoryPlaceholder": "Kategorie auswählen",
    "notFound": "Prozess nicht gefunden",
    "detailDescription": "Prozessdetails anzeigen und verwalten",
    "details": "Prozessdetails",
    "totalSteps": "Gesamtschritte",
    "stepCount": "Schritte",
    "stepsCount_one": "{{count}} Schritt",
    "stepsCount_other": "{{count}} Schritte",
    "draftEdited": "Bearbeitet am {{when}}",
    "draftEditedBy": "Bearbeitet am {{when}} von {{name}}",
    "recordedHeader": "Aufgenommen",
    "recordedTooltip": "aufgenommene Schritte / Gesamt bekannte Schritte",
    "averageRating": "Bewertung",
    "rating": "Bewertung",
    "Accountable": "Rechenschaftspflichtig",
    "ProcessOwner": "Prozessverantwortlicher",
    "involvedEntities": "Beteiligte Entitäten",
    "involvedPeople": "Personen",
    "involvedTeams": "Teams",
    "involvedFunctions": "Funktionen",
    "usedSystems": "Systeme",
    "usedArtifacts": "Unterlagen",
    "externalContacts": "Externe Kontakte",
    "usageAssigned": "Zugewiesen für",
    "usageRecorded": "Aufgenommen von",
    "usageWhoElseDoesThis": "Wer macht das noch",
    "usageHelper": "Helfer in",
    "noInvolvedPeople": "Keine Personen beteiligt",
    "noUsedSystems": "Keine Systeme verwendet",
    "noUsedArtifacts": "Keine Unterlagen verwendet",
    "noExternalContacts": "Keine externen Kontakte beteiligt",
    "processSteps": "Prozessschritte",
    "processStep": "Prozessschritt",
    "stepNumber": "Schritt Nr.",
    "successorNumber": "Folgeschritt Nr.",
    "successor": "Folgeschritt",
    "branches": "Verzweigungen",
    "stepsSheet": "Schritte",
    "frequencyLabel": "Häufigkeit",
    "duration": "Dauer",
    "inputs": "Eingaben",
    "output": "Ausgabe",
    "processStepMembers": "Prozessschritt-Mitglieder",
    "helperSystems": "Helfer (Systeme)",
    "helperPersons": "Helfer (Personen)",
    "helperOrgFunctions": "Helfer (Funktionen)",
    "helperDocuments": "Helfer (Unterlagen)",
    "lastChange": "Letzte Änderung",
    "variants": "Varianten",
    "capacityBinding": "Kapazitätsbindung",
    "responseCoverage": "Konfidenz: {{percent}} der erwarteten Befragten haben geantwortet",
    "noSteps": "Keine Prozessschritte gefunden",
    "minutesValue": "{{value}}min",
    "stepRecordedBy": "Schritt aufgenommen von {{name}}",
    "frequency": {
      "weekly": "Wöchentlich",
      "daily": "Täglich",
      "monthly": "Monatlich",
      "multiple-times-daily": "Mehrmals täglich",
      "once-a-day": "Einmal am Tag",
      "several-times-a-week": "Mehrmals pro Woche",
      "once-per-week": "Einmal pro Woche",
      "every-two-weeks": "Alle zwei Wochen",
      "every-three-weeks": "Alle drei Wochen",
      "quarterly": "Vierteljährlich",
      "semi-annually": "Halbjährlich",
      "yearly": "Jährlich",
      "timesSuffix": " ({{count}}×)"
    },
    "statusNotStarted": "Nicht gestartet",
    "statusInProgress": "In Aufnahme",
    "statusCompleted": "Abgeschlossen",
    "statusRecordingComplete": "Aufgenommen",
    "pendingSurveyCount_one": "{{count}} Umfrage offen",
    "pendingSurveyCount_other": "{{count}} Umfragen offen",
    "deleteConfirmDescription": "Bist du sicher, dass du diesen Prozess löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "duplicateTitle": "Prozess duplizieren",
    "duplicateDescription": "Erstelle eine Kopie von \"{{name}}\" inklusive aufgenommener Schritte, Zuweisungen, Notizen und Layout.",
    "duplicateNameDefault": "{{name}} (Kopie)",
    "duplicateSuccess": "Prozess erfolgreich dupliziert",
    "duplicateFailed": "Prozess konnte nicht dupliziert werden",
    "incompleteStep": "In Bearbeitung",
    "type": "Typ",
    "task": "Aufgabe",
    "decision": "Entscheidung",
    "decisionWithRules": "Entscheidung: {{count}} Regeln",
    "conditions": "Bedingungen",
    "stepDescription": "Schrittbeschreibung",
    "pendingAssignments": "Ausstehende Zuweisungen",
    "assignedTo": "Zugewiesen an",
    "assignedBy": "Zugewiesen von",
    "sourceStep": "Quellschritt",
    "status": "Status",
    "assignedDate": "Zuweisungsdatum",
    "noPendingAssignments": "Keine ausstehenden Zuweisungen",
    "processStart": "Prozessstart",
    "assignmentStatus": {
      "pending": "Ausstehend",
      "accepted": "Akzeptiert",
      "rejected-reassigned": "Abgelehnt - Neu zugewiesen",
      "rejected-unclear": "Abgelehnt - Unklar",
      "pending-unclear": "Ausstehend - Unklar",
      "unclear-reassigned": "Unklar - Neu zugewiesen"
    },
    "createProcessesPage": {
      "title": "Prozesse erstellen",
      "description": "Füge Prozesse zu deiner Prozesswelt hinzu. Entweder indem du sie manuell anlegst oder indem du sie aus Excel hochlädst.",
      "editProcessDescription": "Aktualisiere die Details dieses Prozesses",
      "addManually": "Manuell hinzufügen",
      "addManuallyDescription": "Erstelle einen Prozess über das Formular",
      "uploadFromExcel": "Aus Excel hochladen",
      "uploadFromExcelDescription": "Importiere mehrere Prozesse aus einer Excel-Datei",
      "draftProcesses": "Prozessentwürfe",
      "noDrafts": "Noch keine Prozessentwürfe. Füge Prozesse hinzu, um sie offiziell in BLIKS IO anzulegen.",
      "createAll": "Alle Prozesse erstellen",
      "cancel": "Abbrechen",
      "uploadSuccess_one": "{{count}} Prozess erfolgreich aus Excel hinzugefügt",
      "uploadSuccess_other": "{{count}} Prozesse erfolgreich aus Excel hinzugefügt",
      "editProcessTitle": "Prozess bearbeiten",
      "confirmDelete": "Bist du sicher, dass du diesen Prozess löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
      "successCreated_one": "{{count}} Prozess erfolgreich erstellt",
      "successCreated_other": "{{count}} Prozesse erfolgreich erstellt",
      "validationErrors": "Validierungsfehler",
      "fixErrorsWarning": "Bitte behebe die Validierungsfehler, bevor du Prozesse erstellst",
      "noDepartmentHead": "Der ausgewählten Abteilung ist kein Abteilungsleiter zugewiesen."
    },
    "capacitySourceSurvey": "Erhoben",
    "capacitySourceManual": "Manuell",
    "capacityManualMark": "manuell erfasst",
    "capacityEffective": "wirksam",
    "capacityIncludesManual": "enthält manuelle Werte",
    "capacityConfidence": "Konfidenz: {{percent}}"
  },
  "stepRecording": {
    "confirmReassign": {
      "title": "Neuzuweisung bestätigen",
      "description": "Dein aktueller Fortschritt wird unwiderruflich gelöscht. Bist du sicher, dass du diese Aufgabe neu zuweisen möchtest?",
      "assigneeLabel": "Neu zuweisen an",
      "unclearBody": "Diese Aufgabe wird als unklar markiert und an den Prozessverantwortlichen eskaliert."
    },
    "reassignSuccess": "Aufgabe erfolgreich neu zugewiesen",
    "reassignError": "Fehler beim Neu zuweisen der Aufgabe. Bitte versuche es erneut.",
    "reassignMissingInfo": "Neuzuweisung nicht möglich: fehlende Aufzeichnungsinformationen",
    "finishError": "Aufzeichnung konnte nicht abgeschlossen werden",
    "stopError": "Aufzeichnung konnte nicht gestoppt werden",
    "resumeError": "Rückkehr zur Bearbeitung fehlgeschlagen",
    "retryError": "Erneute Erstellung der Zusammenfassung fehlgeschlagen",
    "review": {
      "title": "Schritt Zusammenfassung",
      "subtitle": "Übernimm den Vorschlag oder passe einzelne Felder über das Stiftsymbol an",
      "subtitleManual": "Gib Titel und Beschreibung für diesen Schritt ein.",
      "titlePlaceholder": "Titel eingeben",
      "descriptionPlaceholder": "Beschreibung eingeben",
      "titleLabel": "Titel",
      "descriptionLabel": "Beschreibung",
      "back": "Zurück",
      "apply": "Übernehmen",
      "editTitle": "Titel bearbeiten",
      "editDescription": "Beschreibung bearbeiten",
      "confirmEdit": "Änderung übernehmen",
      "cancelEdit": "Änderung verwerfen",
      "generating": "Vorschlag wird erstellt…",
      "generatingBanner": "Bliksy erstellt deinen Schritt-Vorschlag…",
      "bliksySuggestion": "Bliksy-Vorschlag",
      "failed": "Erstellung der Zusammenfassung fehlgeschlagen.",
      "retry": "Erneut versuchen",
      "regenerate": "KI-Zusammenfassung neu erstellen",
      "aiError": "KI-Zusammenfassungserstellung fehlgeschlagen. Verwende die Schaltfläche 'Neu erstellen' oder fülle die Felder manuell aus."
    }
  },
  "processMap": {
    "title": "Prozesslandkarte",
    "empty": "Noch keine Prozesse vorhanden. Erstelle Prozesse, um die Landkarte aufzubauen",
    "kpi": {
      "total": "Prozesse",
      "core": "Kernprozesse",
      "management": "Managementprozesse",
      "support": "Supportprozesse",
      "connections": "Verbundene Prozesse",
      "isolated": "Isolierte Prozesse"
    },
    "lanes": {
      "management": "Management",
      "core": "Kern",
      "support": "Support",
      "uncategorized": "Unkategorisiert"
    },
    "uncategorizedHint": "{{count}} Prozesse sind noch nicht kategorisiert. Weise ihnen eine Kategorie (Kern/Management/Support) zu, um die Landkarte zu strukturieren.",
    "editorMode": "Bearbeiten",
    "resetLayout": "Layout zurücksetzen",
    "resetLayoutConfirm": "Alle manuellen Positionierungen werden zurückgesetzt und das automatische Layout wiederhergestellt. Fortfahren?",
    "saveChanges": "Speichern",
    "discardChanges": "Verwerfen",
    "tooltip": {
      "connected": "Verknüpft",
      "notConnected": "Nicht verknüpft",
      "from": "Von",
      "to": "Nach",
      "outputLabel": "Ausgabe",
      "startEventLabel": "Startereignis"
    },
    "departmentFilter": {
      "placeholder": "Abteilungen",
      "search": "Abteilungen suchen...",
      "empty": "Keine Abteilungen gefunden",
      "selected": "{{count}} Abteilungen",
      "modeHighlight": "Hervorhebungsmodus: blendet nicht-passende Prozesse aus",
      "modeFilter": "Filtermodus: entfernt nicht-passende Prozesse"
    },
    "search": {
      "placeholder": "Prozesse suchen...",
      "noResults": "Keine Treffer"
    },
    "chainFilter": {
      "placeholder": "Prozessketten",
      "search": "Kette suchen...",
      "empty": "Keine Ketten mit Prozessen",
      "selected": "{{count}} Ketten",
      "modeHighlight": "Hervorhebungsmodus: blendet nicht-passende Prozesse aus",
      "modeFilter": "Filtermodus: entfernt nicht-passende Prozesse"
    },
    "editorHints": {
      "dragNode": "Prozess verschieben",
      "selectArea": "Bereich auswählen",
      "pan": "Ansicht verschieben",
      "multiSelect": "Zur Auswahl hinzufügen",
      "clickPort": "Verknüpfung erstellen",
      "leftClick": "Links",
      "rightClick": "Rechts",
      "shift": "Shift",
      "dragOnNode": "Ziehen auf Prozess",
      "dragOnCanvas": "Ziehen auf Fläche"
    },
    "connectDialog": {
      "title": "Verknüpfung erstellen",
      "description": "Möchtest du die Verknüpfung herstellen?",
      "duplicateTitle": "Verbindung existiert bereits",
      "duplicateDescription": "Diese Verbindung besteht bereits zwischen den gewählten Ports.",
      "duplicateWarning": "Eine identische Verbindung existiert bereits. Sie kann nicht erneut erstellt werden.",
      "confirm": "verknüpfen"
    },
    "focusBadge": "Fokus: {{name}}",
    "miniMap": {
      "title": "Prozessfluss",
      "showInLandscape": "In Landkarte anzeigen",
      "noConnections": "Keine Verknüpfungen"
    }
  },
  "connections": {
    "title": "Verknüpfungen",
    "noConnections": "Dieser Prozess hat noch keine Verknüpfungen",
    "predecessors": "Vorgänger",
    "successors": "Nachfolger",
    "unconnectedPorts": "Nicht verknüpfte Ports",
    "notConnected": "Nicht verknüpft",
    "addPredecessor": "Vorgänger hinzufügen",
    "addSuccessor": "Nachfolger hinzufügen",
    "assignConnection": "Zuordnen",
    "deleteConnection": "Verbindung löschen",
    "deleteConnectionConfirm": "Bist du sicher, dass du diese Verbindung löschen möchtest?",
    "manageConnections": {
      "title": "Verknüpfungen verwalten: {{portName}}",
      "description": "Wähle Prozesse und deren Ports aus, um Verbindungen herzustellen.",
      "inputLabel": "Quellprozesse & deren Outputs",
      "outputLabel": "Zielprozesse & deren Inputs",
      "save": "Speichern",
      "saving": "Wird gespeichert...",
      "saveFailed": "Verbindungen konnten nicht gespeichert werden"
    }
  },
  "portConnectionSelector": {
    "searchPlaceholder": "Prozess suchen...",
    "selectedCount": "{{count}} Prozess(e) ausgewählt",
    "noInputs": "Keine Inputs vorhanden",
    "noOutputs": "Keine Outputs vorhanden",
    "allDepartments": "Alle Abteilungen",
    "outputCount": "{{count}} Output(s)",
    "inputCount": "{{count}} Input(s)"
  },
  "processChains": {
    "title": "Prozessketten",
    "createChain": "Neue Prozesskette",
    "categories": {
      "management": "Management",
      "core": "Kern",
      "support": "Support"
    },
    "empty": {
      "title": "Keine Prozessketten vorhanden",
      "description": "Erstelle Prozessketten, um deine Prozesse in End-to-End-Abläufe zu gruppieren."
    },
    "createDialog": {
      "name": "Kettenname",
      "namePlaceholder": "z.B. „Order-to-Cash“",
      "description": "Beschreibung",
      "descriptionPlaceholder": "Kurze Beschreibung der Prozesskette (optional)",
      "category": "Prozessketten-Kategorie"
    },
    "editChain": {
      "title": "Prozesskette bearbeiten",
      "description": "Name, Beschreibung und Kategorie dieser Prozesskette ändern."
    },
    "edit": {
      "button": "Bearbeiten",
      "title": "Prozesse in der Kette verwalten",
      "description": "Prozesse zu dieser Kette hinzufügen, entfernen oder umsortieren.",
      "addProcess": "Prozess hinzufügen...",
      "noProcesses": "Noch keine Prozesse zugewiesen",
      "addProcesses": "Prozesse hinzufügen",
      "swimlane": {
        "strategic": "Strategisch",
        "core": "Kern",
        "support": "Support"
      },
      "remove": "Entfernen",
      "autoDetect": {
        "button": "Auto-Erkennung",
        "title": "Prozesskette auto-erkennen",
        "description": "Wähle einen Startprozess. Alle verknüpften Prozesse werden automatisch erkannt",
        "selectSeed": "Startprozess auswählen...",
        "detected": "{{count}} Prozesse erkannt",
        "addAll": "Alle zur Kette hinzufügen",
        "noConnections": "Dieser Prozess hat keine Verbindungen zu anderen Prozessen."
      },
      "suggestions": {
        "title": "Vorgeschlagene Prozesse",
        "hint": "Verbunden mit Prozessen in dieser Kette"
      }
    },
    "detail": {
      "noSubChains": "Keine Unterketten vorhanden.",
      "emptyChainHint": "Diese Kette enthält noch keine Prozesse oder Unterketten."
    },
    "deleteChain": {
      "button": "Kette löschen",
      "title": "Kette löschen",
      "description": "Möchtest du die Kette \"{{name}}\" wirklich löschen?",
      "processesWillBeFreed": "{{count}} Prozess(e) werden aus der Kette entfernt",
      "childChainsWillBeDeleted": "{{count}} Unterkette(n) werden ebenfalls gelöscht",
      "confirm": "Kette löschen"
    },
    "drillDown": {
      "root": "Prozessketten",
      "childChains": "{{count}} Unterketten",
      "processes": "{{count}} Prozesse",
      "emptyChain": "Diese Kette enthält noch keine Unterketten oder Prozesse.",
      "createSubChain": "Unterkette erstellen",
      "createHere": "Neue Kette erstellen",
      "editProcesses": "Prozesse bearbeiten"
    }
  },
  "flowKit": {
    "toolbar": {
      "fitView": "Ansicht anpassen",
      "autoLayout": "Automatisches Layout",
      "undo": "Rückgängig",
      "redo": "Wiederholen",
      "handTool": "Hand-Werkzeug (H)",
      "selectTool": "Auswahl-Werkzeug (V)"
    }
  },
  "stepTemplates": {
    "saveDialog": {
      "title": "Als Schrittvorlage speichern",
      "name": "Name",
      "description": "Beschreibung",
      "selectedCount_one": "{{count}} Element ausgewählt",
      "selectedCount_other": "{{count}} Elemente ausgewählt",
      "unnamedStep": "Unbenannter Schritt",
      "unnamedEvent": "Unbenanntes Ereignis",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "saved": "Schrittvorlage „{{name}}“ gespeichert"
    },
    "insertDialog": {
      "title": "Schrittvorlage einfügen",
      "empty": "Noch keine Schrittvorlagen gespeichert.",
      "loadError": "Schrittvorlagen konnten nicht geladen werden.",
      "insert": "Einfügen",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "save": "Speichern",
      "meta_one": "{{count}} Element · {{author}} · {{date}}",
      "meta_other": "{{count}} Elemente · {{author}} · {{date}}",
      "deleteConfirm": {
        "title": "Schrittvorlage löschen",
        "body": "„{{name}}“ wird dauerhaft aus der Liste entfernt. Bereits eingefügte Schritte bleiben unverändert."
      },
      "inserted": "„{{name}}“ eingefügt"
    },
    "error": "Aktion fehlgeschlagen"
  }
}
